// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Thin executor wrapper functions for GraphQL operations
// =============================================================================

import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'
import {
  AddRideMovesDocument,
  AddScenariosToBundleDocument,
  AssignMoveToDriverDocument,
  AssignOfferToBundleDocument,
  BatchLinkMovesToScenarioDocument,
  CreateAccessorialsDocument,
  CreateBundleDocument,
  CreateBundleSetDocument,
  CreateLaneShellPairDocument,
  CreateLocationDocument,
  CreateOfferDocument,
  CreatePlanForDriverDocument,
  CreateScenarioDocument,
  DeleteBundleDocument,
  DeleteExpiredEventsByActionDocument,
  DeleteFaqDocument,
  DeleteMoveLinksDocument,
  ExpireOldOffersOfBundleDocument,
  FindGeocodeCacheDocument,
  FindLocationByInputAliasDocument,
  FindLocationsByPlaceIdDocument,
  FindLocationsNearbyDocument,
  GetActionTypeByNameDocument,
  GetActionTypesDocument,
  GetAlgorithmsOptionsDocument,
  GetBundleByIdDocument,
  GetBundleForDriverPoolDocument,
  GetBundleWithMoveDetailsDocument,
  GetBundleWithMoveDetailsLightweightDocument,
  GetCertificationsOptionsDocument,
  GetConfigsDocument,
  GetCustomerConfigDocument,
  GetCustomerstocertificationsDocument,
  GetDriverBlacklistByLocationsDocument,
  GetDriverByIdDocument,
  GetDriversInRadiusByStartingLocationDocument,
  GetDriversLatestLocationDocument,
  GetExistingPlansDocument,
  GetFaqDocument,
  GetLaneByIdDocument,
  GetLaneWithInverseDocument,
  GetLaneWithLocationsDocument,
  GetLocationByCustomerRefDocument,
  GetLocationByIdDocument,
  GetMoveByIdDocument,
  GetMoveConfigDocument,
  GetMoveDetailsDocument,
  GetOfferByIdDocument,
  GetOffersForBundleDocument,
  GetOffersForBundleBasicDocument,
  GetOrganizationConfigDocument,
  GetPendingOffersDocument,
  GetPlanByDriverIdDocument,
  GetRateruleGroupConfigDocument,
  GetRegionConfigDocument,
  GetRegionstocertificationsDocument,
  GetRequiredCertificationsDocument,
  GetRideAccessorialsDocument,
  GetRidegroupAccessorialsDocument,
  GetRoleTypeByNameDocument,
  GetScenarioDocument,
  GetScenarioBundleDocument,
  GetScenarioByIdDocument,
  GetScenariosByIdsDocument,
  GetScenarioToConvertOrRepairDocument,
  GetScenarioWithMovesDocument,
  GetWorkflowsetConfigDocument,
  Insert_RidegroupsDocument,
  InsertEventlogDocument,
  InsertFaqDocument,
  InsertTriangleAccessorialDocument,
  InverseConciergeDocument,
  InverseConciergeLoanerDocument,
  InverseFlexibleFlagsDocument,
  LinkMoveToScenarioDocument,
  LinkScenarioToBundleDocument,
  RecordInputAliasDocument,
  RemoveAccessorialsDocument,
  RemoveAppaymentsDocument,
  RemoveRideMovesDocument,
  ResolveLaneByLocationsDocument,
  SetRegionstocertificationsDocument,
  StorageCustomerConfigGetDocument,
  StorageCustomerConfigSetDocument,
  StorageRegionConfigGetDocument,
  StoreGeocodeCacheDocument,
  TriggerLaneEnrichmentDocument,
  UnassignHangtagDocument,
  UpdateAccessorialDocument,
  UpdateAllOfferStatusesForBundleDocument,
  UpdateBundleConfigDocument,
  UpdateBundleScenariosStatusDocument,
  UpdateBundleStatusDocument,
  UpdateBundleStatusesDocument,
  UpdateFaqFullDocument,
  UpdateLaneEnrichmentDocument,
  UpdateLaneStatusDocument,
  UpdateLaneStatusReadyDocument,
  UpdateMoveWithAdjustmentsDocument,
  UpdateOfferStatusDocument,
  UpdatePickupAndDeliveryTimeDocument,
  UpdateRescheduledMoveDocument,
  UpdateRideAccessorialDocument,
  UpdateRidesDocument,
  UpdateScenarioConfigDocument,
  UpdateScenarioStatusDocument,
  UpdateScenarioStatusesDocument,
  UpdateScenarioTypeDocument,
  UpdateScenarioWorkflowDataDocument,
  UpdateSurgeAccessorialDocument,
  UpdateTriangleRideAccessorialDocument,
  Upsert_MovesDocument,
  UpsertRideMovesDocument,
  type AddRideMovesMutation,
  type AddScenariosToBundleMutation,
  type AssignMoveToDriverMutation,
  type AssignOfferToBundleMutation,
  type BatchLinkMovesToScenarioMutation,
  type CreateAccessorialsMutation,
  type CreateBundleMutation,
  type CreateBundleSetMutation,
  type CreateLaneShellPairMutation,
  type CreateLocationMutation,
  type CreateOfferMutation,
  type CreatePlanForDriverMutation,
  type CreateScenarioMutation,
  type DeleteBundleMutation,
  type DeleteExpiredEventsByActionMutation,
  type DeleteFaqMutation,
  type DeleteMoveLinksMutation,
  type ExpireOldOffersOfBundleMutation,
  type FindGeocodeCacheQuery,
  type FindLocationByInputAliasQuery,
  type FindLocationsByPlaceIdQuery,
  type FindLocationsNearbyQuery,
  type GetActionTypeByNameQuery,
  type GetActionTypesQuery,
  type GetAlgorithmsOptionsQuery,
  type GetBundleByIdQuery,
  type GetBundleForDriverPoolQuery,
  type GetBundleWithMoveDetailsQuery,
  type GetBundleWithMoveDetailsLightweightQuery,
  type GetCertificationsOptionsQuery,
  type GetConfigsQuery,
  type GetCustomerConfigQuery,
  type GetCustomerstocertificationsQuery,
  type GetDriverBlacklistByLocationsQuery,
  type GetDriverByIdQuery,
  type GetDriversInRadiusByStartingLocationQuery,
  type GetDriversLatestLocationQuery,
  type GetExistingPlansQuery,
  type GetFaqQuery,
  type GetLaneByIdQuery,
  type GetLaneWithInverseQuery,
  type GetLaneWithLocationsQuery,
  type GetLocationByCustomerRefQuery,
  type GetLocationByIdQuery,
  type GetMoveByIdQuery,
  type GetMoveConfigQuery,
  type GetMoveDetailsQuery,
  type GetOfferByIdQuery,
  type GetOffersForBundleQuery,
  type GetOffersForBundleBasicQuery,
  type GetOrganizationConfigQuery,
  type GetPendingOffersQuery,
  type GetPlanByDriverIdQuery,
  type GetRateruleGroupConfigQuery,
  type GetRegionConfigQuery,
  type GetRegionstocertificationsQuery,
  type GetRequiredCertificationsQuery,
  type GetRideAccessorialsQuery,
  type GetRidegroupAccessorialsQuery,
  type GetRoleTypeByNameQuery,
  type GetScenarioQuery,
  type GetScenarioBundleQuery,
  type GetScenarioByIdQuery,
  type GetScenariosByIdsQuery,
  type GetScenarioToConvertOrRepairQuery,
  type GetScenarioWithMovesQuery,
  type GetWorkflowsetConfigQuery,
  type Insert_RidegroupsMutation,
  type InsertEventlogMutation,
  type InsertFaqMutation,
  type InsertTriangleAccessorialMutation,
  type InverseConciergeMutation,
  type InverseConciergeLoanerMutation,
  type InverseFlexibleFlagsMutation,
  type LinkMoveToScenarioMutation,
  type LinkScenarioToBundleMutation,
  type RecordInputAliasMutation,
  type RemoveAccessorialsMutation,
  type RemoveAppaymentsMutation,
  type RemoveRideMovesMutation,
  type ResolveLaneByLocationsQuery,
  type SetRegionstocertificationsMutation,
  type StorageCustomerConfigGetQuery,
  type StorageCustomerConfigSetMutation,
  type StorageRegionConfigGetQuery,
  type StoreGeocodeCacheMutation,
  type TriggerLaneEnrichmentMutation,
  type UnassignHangtagMutation,
  type UpdateAccessorialMutation,
  type UpdateAllOfferStatusesForBundleMutation,
  type UpdateBundleConfigMutation,
  type UpdateBundleScenariosStatusMutation,
  type UpdateBundleStatusMutation,
  type UpdateBundleStatusesMutation,
  type UpdateFaqFullMutation,
  type UpdateLaneEnrichmentMutation,
  type UpdateLaneStatusMutation,
  type UpdateLaneStatusReadyMutation,
  type UpdateMoveWithAdjustmentsMutation,
  type UpdateOfferStatusMutation,
  type UpdatePickupAndDeliveryTimeMutation,
  type UpdateRescheduledMoveMutation,
  type UpdateRideAccessorialMutation,
  type UpdateRidesMutation,
  type UpdateScenarioConfigMutation,
  type UpdateScenarioStatusMutation,
  type UpdateScenarioStatusesMutation,
  type UpdateScenarioTypeMutation,
  type UpdateScenarioWorkflowDataMutation,
  type UpdateSurgeAccessorialMutation,
  type UpdateTriangleRideAccessorialMutation,
  type Upsert_MovesMutation,
  type UpsertRideMovesMutation,
  type AddRideMovesMutationVariables,
  type AddScenariosToBundleMutationVariables,
  type AssignMoveToDriverMutationVariables,
  type AssignOfferToBundleMutationVariables,
  type BatchLinkMovesToScenarioMutationVariables,
  type CreateAccessorialsMutationVariables,
  type CreateBundleMutationVariables,
  type CreateBundleSetMutationVariables,
  type CreateLaneShellPairMutationVariables,
  type CreateLocationMutationVariables,
  type CreateOfferMutationVariables,
  type CreatePlanForDriverMutationVariables,
  type CreateScenarioMutationVariables,
  type DeleteBundleMutationVariables,
  type DeleteExpiredEventsByActionMutationVariables,
  type DeleteFaqMutationVariables,
  type DeleteMoveLinksMutationVariables,
  type ExpireOldOffersOfBundleMutationVariables,
  type FindGeocodeCacheQueryVariables,
  type FindLocationByInputAliasQueryVariables,
  type FindLocationsByPlaceIdQueryVariables,
  type FindLocationsNearbyQueryVariables,
  type GetActionTypeByNameQueryVariables,
  type GetActionTypesQueryVariables,
  type GetAlgorithmsOptionsQueryVariables,
  type GetBundleByIdQueryVariables,
  type GetBundleForDriverPoolQueryVariables,
  type GetBundleWithMoveDetailsQueryVariables,
  type GetBundleWithMoveDetailsLightweightQueryVariables,
  type GetCertificationsOptionsQueryVariables,
  type GetConfigsQueryVariables,
  type GetCustomerConfigQueryVariables,
  type GetCustomerstocertificationsQueryVariables,
  type GetDriverBlacklistByLocationsQueryVariables,
  type GetDriverByIdQueryVariables,
  type GetDriversInRadiusByStartingLocationQueryVariables,
  type GetDriversLatestLocationQueryVariables,
  type GetExistingPlansQueryVariables,
  type GetFaqQueryVariables,
  type GetLaneByIdQueryVariables,
  type GetLaneWithInverseQueryVariables,
  type GetLaneWithLocationsQueryVariables,
  type GetLocationByCustomerRefQueryVariables,
  type GetLocationByIdQueryVariables,
  type GetMoveByIdQueryVariables,
  type GetMoveConfigQueryVariables,
  type GetMoveDetailsQueryVariables,
  type GetOfferByIdQueryVariables,
  type GetOffersForBundleQueryVariables,
  type GetOffersForBundleBasicQueryVariables,
  type GetOrganizationConfigQueryVariables,
  type GetPendingOffersQueryVariables,
  type GetPlanByDriverIdQueryVariables,
  type GetRateruleGroupConfigQueryVariables,
  type GetRegionConfigQueryVariables,
  type GetRegionstocertificationsQueryVariables,
  type GetRequiredCertificationsQueryVariables,
  type GetRideAccessorialsQueryVariables,
  type GetRidegroupAccessorialsQueryVariables,
  type GetRoleTypeByNameQueryVariables,
  type GetScenarioQueryVariables,
  type GetScenarioBundleQueryVariables,
  type GetScenarioByIdQueryVariables,
  type GetScenariosByIdsQueryVariables,
  type GetScenarioToConvertOrRepairQueryVariables,
  type GetScenarioWithMovesQueryVariables,
  type GetWorkflowsetConfigQueryVariables,
  type Insert_RidegroupsMutationVariables,
  type InsertEventlogMutationVariables,
  type InsertFaqMutationVariables,
  type InsertTriangleAccessorialMutationVariables,
  type InverseConciergeMutationVariables,
  type InverseConciergeLoanerMutationVariables,
  type InverseFlexibleFlagsMutationVariables,
  type LinkMoveToScenarioMutationVariables,
  type LinkScenarioToBundleMutationVariables,
  type RecordInputAliasMutationVariables,
  type RemoveAccessorialsMutationVariables,
  type RemoveAppaymentsMutationVariables,
  type RemoveRideMovesMutationVariables,
  type ResolveLaneByLocationsQueryVariables,
  type SetRegionstocertificationsMutationVariables,
  type StorageCustomerConfigGetQueryVariables,
  type StorageCustomerConfigSetMutationVariables,
  type StorageRegionConfigGetQueryVariables,
  type StoreGeocodeCacheMutationVariables,
  type TriggerLaneEnrichmentMutationVariables,
  type UnassignHangtagMutationVariables,
  type UpdateAccessorialMutationVariables,
  type UpdateAllOfferStatusesForBundleMutationVariables,
  type UpdateBundleConfigMutationVariables,
  type UpdateBundleScenariosStatusMutationVariables,
  type UpdateBundleStatusMutationVariables,
  type UpdateBundleStatusesMutationVariables,
  type UpdateFaqFullMutationVariables,
  type UpdateLaneEnrichmentMutationVariables,
  type UpdateLaneStatusMutationVariables,
  type UpdateLaneStatusReadyMutationVariables,
  type UpdateMoveWithAdjustmentsMutationVariables,
  type UpdateOfferStatusMutationVariables,
  type UpdatePickupAndDeliveryTimeMutationVariables,
  type UpdateRescheduledMoveMutationVariables,
  type UpdateRideAccessorialMutationVariables,
  type UpdateRidesMutationVariables,
  type UpdateScenarioConfigMutationVariables,
  type UpdateScenarioStatusMutationVariables,
  type UpdateScenarioStatusesMutationVariables,
  type UpdateScenarioTypeMutationVariables,
  type UpdateScenarioWorkflowDataMutationVariables,
  type UpdateSurgeAccessorialMutationVariables,
  type UpdateTriangleRideAccessorialMutationVariables,
  type Upsert_MovesMutationVariables,
  type UpsertRideMovesMutationVariables,
} from './schema'


/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/addRideMoves.mutation.gql}
 */
export async function addRideMoves(
  variables: AddRideMovesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<AddRideMovesMutation['insert_scenariotomoves']>
export async function addRideMoves(
  variables: AddRideMovesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<AddRideMovesMutation>
export async function addRideMoves(
  variables: AddRideMovesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<AddRideMovesMutation['insert_scenariotomoves'] | AddRideMovesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<AddRideMovesMutation>(
    AddRideMovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_scenariotomoves
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/addScenariosToBundle.mutation.gql}
 */
export async function addScenariosToBundle(
  variables: AddScenariosToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<AddScenariosToBundleMutation['insert_bundletoscenarios']>
export async function addScenariosToBundle(
  variables: AddScenariosToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<AddScenariosToBundleMutation>
export async function addScenariosToBundle(
  variables: AddScenariosToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<AddScenariosToBundleMutation['insert_bundletoscenarios'] | AddScenariosToBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<AddScenariosToBundleMutation>(
    AddScenariosToBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_bundletoscenarios
}

/**
 * @source {@link packages/dispatch/src/features/timeline/gql/assignMovesToPlan.mutation.gql}
 */
export async function assignMoveToDriver(
  variables: AssignMoveToDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<AssignMoveToDriverMutation['update_moves']>
export async function assignMoveToDriver(
  variables: AssignMoveToDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<AssignMoveToDriverMutation>
export async function assignMoveToDriver(
  variables: AssignMoveToDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<AssignMoveToDriverMutation['update_moves'] | AssignMoveToDriverMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<AssignMoveToDriverMutation>(
    AssignMoveToDriverDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/assignOfferToBundle.mutation.gql}
 */
export async function assignOfferToBundle(
  variables: AssignOfferToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<AssignOfferToBundleMutation['update_bundles_by_pk']>
export async function assignOfferToBundle(
  variables: AssignOfferToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<AssignOfferToBundleMutation>
export async function assignOfferToBundle(
  variables: AssignOfferToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<AssignOfferToBundleMutation['update_bundles_by_pk'] | AssignOfferToBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<AssignOfferToBundleMutation>(
    AssignOfferToBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_bundles_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/batchLinkMovesToScenario.mutation.gql}
 */
export async function batchLinkMovesToScenario(
  variables: BatchLinkMovesToScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<BatchLinkMovesToScenarioMutation['insert_scenariotomoves']>
export async function batchLinkMovesToScenario(
  variables: BatchLinkMovesToScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<BatchLinkMovesToScenarioMutation>
export async function batchLinkMovesToScenario(
  variables: BatchLinkMovesToScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<BatchLinkMovesToScenarioMutation['insert_scenariotomoves'] | BatchLinkMovesToScenarioMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<BatchLinkMovesToScenarioMutation>(
    BatchLinkMovesToScenarioDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_scenariotomoves
}

/**
 * @source {@link packages/accessorials/src/features/shared/operations/gql/createAccessorials.mutation.gql}
 */
export async function createAccessorials(
  variables: CreateAccessorialsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateAccessorialsMutation['insert_accessorials']>
export async function createAccessorials(
  variables: CreateAccessorialsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateAccessorialsMutation>
export async function createAccessorials(
  variables: CreateAccessorialsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateAccessorialsMutation['insert_accessorials'] | CreateAccessorialsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateAccessorialsMutation>(
    CreateAccessorialsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_accessorials
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/createBundle.mutation.gql}
 */
export async function createBundle(
  variables: CreateBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateBundleMutation['insert_bundles_one']>
export async function createBundle(
  variables: CreateBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateBundleMutation>
export async function createBundle(
  variables: CreateBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateBundleMutation['insert_bundles_one'] | CreateBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateBundleMutation>(
    CreateBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_bundles_one
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/createBundleSet.mutation.gql}
 */
export async function createBundleSet(
  variables: CreateBundleSetMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateBundleSetMutation['insert_bundlesets_one']>
export async function createBundleSet(
  variables: CreateBundleSetMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateBundleSetMutation>
export async function createBundleSet(
  variables: CreateBundleSetMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateBundleSetMutation['insert_bundlesets_one'] | CreateBundleSetMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateBundleSetMutation>(
    CreateBundleSetDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_bundlesets_one
}

/**
 * Multiple root fields (forward, inverse): returns the full response object.
 * @source {@link packages/lanes/src/features/resolve-lane/gql/createLaneShellPair.mutation.gql}
 */
export async function createLaneShellPair(
  variables: CreateLaneShellPairMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<CreateLaneShellPairMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<CreateLaneShellPairMutation>(
    CreateLaneShellPairDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link packages/lanes/src/features/resolve-location/gql/createLocation.mutation.gql}
 */
export async function createLocation(
  variables: CreateLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateLocationMutation['insert_locations_one']>
export async function createLocation(
  variables: CreateLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateLocationMutation>
export async function createLocation(
  variables: CreateLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateLocationMutation['insert_locations_one'] | CreateLocationMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateLocationMutation>(
    CreateLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_locations_one
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/createOffer.mutation.gql}
 */
export async function createOffer(
  variables: CreateOfferMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateOfferMutation['insert_offers_one']>
export async function createOffer(
  variables: CreateOfferMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateOfferMutation>
export async function createOffer(
  variables: CreateOfferMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateOfferMutation['insert_offers_one'] | CreateOfferMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateOfferMutation>(
    CreateOfferDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_offers_one
}

/**
 * @source {@link packages/dispatch/src/features/timeline/gql/createPlanForDriver.mutation.gql}
 */
export async function createPlanForDriver(
  variables: CreatePlanForDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreatePlanForDriverMutation['insert_plans']>
export async function createPlanForDriver(
  variables: CreatePlanForDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreatePlanForDriverMutation>
export async function createPlanForDriver(
  variables: CreatePlanForDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreatePlanForDriverMutation['insert_plans'] | CreatePlanForDriverMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreatePlanForDriverMutation>(
    CreatePlanForDriverDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_plans
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/createScenario.mutation.gql}
 */
export async function createScenario(
  variables: CreateScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateScenarioMutation['insert_scenarios_one']>
export async function createScenario(
  variables: CreateScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateScenarioMutation>
export async function createScenario(
  variables: CreateScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateScenarioMutation['insert_scenarios_one'] | CreateScenarioMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateScenarioMutation>(
    CreateScenarioDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_scenarios_one
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/deleteBundle.mutation.gql}
 */
export async function deleteBundle(
  variables: DeleteBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteBundleMutation['delete_bundles_by_pk']>
export async function deleteBundle(
  variables: DeleteBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteBundleMutation>
export async function deleteBundle(
  variables: DeleteBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteBundleMutation['delete_bundles_by_pk'] | DeleteBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteBundleMutation>(
    DeleteBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_bundles_by_pk
}

/**
 * @source {@link packages/events/src/features/purge-events/gql/deleteExpiredEventsByAction.mutation.gql}
 */
export async function deleteExpiredEventsByAction(
  variables: DeleteExpiredEventsByActionMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteExpiredEventsByActionMutation['delete_eventlogs']>
export async function deleteExpiredEventsByAction(
  variables: DeleteExpiredEventsByActionMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteExpiredEventsByActionMutation>
export async function deleteExpiredEventsByAction(
  variables: DeleteExpiredEventsByActionMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteExpiredEventsByActionMutation['delete_eventlogs'] | DeleteExpiredEventsByActionMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteExpiredEventsByActionMutation>(
    DeleteExpiredEventsByActionDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_eventlogs
}

/**
 * @source {@link packages/configs/tests/integration/faq.gql}
 */
export async function deleteFaq(
  variables: DeleteFaqMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteFaqMutation['delete_faqs_by_pk']>
export async function deleteFaq(
  variables: DeleteFaqMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteFaqMutation>
export async function deleteFaq(
  variables: DeleteFaqMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteFaqMutation['delete_faqs_by_pk'] | DeleteFaqMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteFaqMutation>(
    DeleteFaqDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_faqs_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/deleteMoveLinks.mutation.gql}
 */
export async function deleteMoveLinks(
  variables: DeleteMoveLinksMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteMoveLinksMutation['delete_scenariotomoves']>
export async function deleteMoveLinks(
  variables: DeleteMoveLinksMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteMoveLinksMutation>
export async function deleteMoveLinks(
  variables: DeleteMoveLinksMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteMoveLinksMutation['delete_scenariotomoves'] | DeleteMoveLinksMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteMoveLinksMutation>(
    DeleteMoveLinksDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_scenariotomoves
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/expireOldOffers.mutation.gql}
 */
export async function expireOldOffersOfBundle(
  variables: ExpireOldOffersOfBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<ExpireOldOffersOfBundleMutation['update_offers']>
export async function expireOldOffersOfBundle(
  variables: ExpireOldOffersOfBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<ExpireOldOffersOfBundleMutation>
export async function expireOldOffersOfBundle(
  variables: ExpireOldOffersOfBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<ExpireOldOffersOfBundleMutation['update_offers'] | ExpireOldOffersOfBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<ExpireOldOffersOfBundleMutation>(
    ExpireOldOffersOfBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_offers
}

/**
 * @source {@link packages/lanes/src/features/geocoding/gql/findGeocodeCache.query.gql}
 */
export async function findGeocodeCache(
  variables: FindGeocodeCacheQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<FindGeocodeCacheQuery['geocode_cache']>
export async function findGeocodeCache(
  variables: FindGeocodeCacheQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<FindGeocodeCacheQuery>
export async function findGeocodeCache(
  variables: FindGeocodeCacheQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<FindGeocodeCacheQuery['geocode_cache'] | FindGeocodeCacheQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<FindGeocodeCacheQuery>(
    FindGeocodeCacheDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.geocode_cache
}

/**
 * @source {@link packages/lanes/src/features/location-lookup/gql/findLocationByInputAlias.query.gql}
 */
export async function findLocationByInputAlias(
  variables: FindLocationByInputAliasQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<FindLocationByInputAliasQuery['location_input_aliases']>
export async function findLocationByInputAlias(
  variables: FindLocationByInputAliasQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<FindLocationByInputAliasQuery>
export async function findLocationByInputAlias(
  variables: FindLocationByInputAliasQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<FindLocationByInputAliasQuery['location_input_aliases'] | FindLocationByInputAliasQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<FindLocationByInputAliasQuery>(
    FindLocationByInputAliasDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.location_input_aliases
}

/**
 * @source {@link packages/lanes/src/features/location-lookup/gql/findLocationsByPlaceId.query.gql}
 */
export async function findLocationsByPlaceId(
  variables: FindLocationsByPlaceIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<FindLocationsByPlaceIdQuery['locations']>
export async function findLocationsByPlaceId(
  variables: FindLocationsByPlaceIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<FindLocationsByPlaceIdQuery>
export async function findLocationsByPlaceId(
  variables: FindLocationsByPlaceIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<FindLocationsByPlaceIdQuery['locations'] | FindLocationsByPlaceIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<FindLocationsByPlaceIdQuery>(
    FindLocationsByPlaceIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations
}

/**
 * @source {@link packages/lanes/src/features/location-lookup/gql/findLocationsNearby.query.gql}
 */
export async function findLocationsNearby(
  variables: FindLocationsNearbyQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<FindLocationsNearbyQuery['locations']>
export async function findLocationsNearby(
  variables: FindLocationsNearbyQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<FindLocationsNearbyQuery>
export async function findLocationsNearby(
  variables: FindLocationsNearbyQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<FindLocationsNearbyQuery['locations'] | FindLocationsNearbyQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<FindLocationsNearbyQuery>(
    FindLocationsNearbyDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations
}

/**
 * @source {@link packages/events/src/features/lookup-types/gql/getActionTypeByName.query.gql}
 */
export async function getActionTypeByName(
  variables: GetActionTypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetActionTypeByNameQuery['actiontypes']>
export async function getActionTypeByName(
  variables: GetActionTypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetActionTypeByNameQuery>
export async function getActionTypeByName(
  variables: GetActionTypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetActionTypeByNameQuery['actiontypes'] | GetActionTypeByNameQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetActionTypeByNameQuery>(
    GetActionTypeByNameDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.actiontypes
}

/**
 * @source {@link packages/events/src/features/lookup-types/gql/getActionTypes.query.gql}
 */
export async function getActionTypes(
  variables: GetActionTypesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetActionTypesQuery['actiontypes']>
export async function getActionTypes(
  variables: GetActionTypesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetActionTypesQuery>
export async function getActionTypes(
  variables: GetActionTypesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetActionTypesQuery['actiontypes'] | GetActionTypesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetActionTypesQuery>(
    GetActionTypesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.actiontypes
}

/**
 * @source {@link packages/configs/tests/storage/gql/enum-options-algorithms.gql}
 */
export async function getAlgorithmsOptions(
  variables: GetAlgorithmsOptionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetAlgorithmsOptionsQuery['algorithms']>
export async function getAlgorithmsOptions(
  variables: GetAlgorithmsOptionsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetAlgorithmsOptionsQuery>
export async function getAlgorithmsOptions(
  variables: GetAlgorithmsOptionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetAlgorithmsOptionsQuery['algorithms'] | GetAlgorithmsOptionsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetAlgorithmsOptionsQuery>(
    GetAlgorithmsOptionsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.algorithms
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/getBundleById.query.gql}
 */
export async function getBundleById(
  variables: GetBundleByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetBundleByIdQuery['bundles_by_pk']>
export async function getBundleById(
  variables: GetBundleByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetBundleByIdQuery>
export async function getBundleById(
  variables: GetBundleByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetBundleByIdQuery['bundles_by_pk'] | GetBundleByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetBundleByIdQuery>(
    GetBundleByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.bundles_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/offer-processing/gql/getBundleForDriverPool.query.gql}
 */
export async function getBundleForDriverPool(
  variables: GetBundleForDriverPoolQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetBundleForDriverPoolQuery['bundles_by_pk']>
export async function getBundleForDriverPool(
  variables: GetBundleForDriverPoolQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetBundleForDriverPoolQuery>
export async function getBundleForDriverPool(
  variables: GetBundleForDriverPoolQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetBundleForDriverPoolQuery['bundles_by_pk'] | GetBundleForDriverPoolQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetBundleForDriverPoolQuery>(
    GetBundleForDriverPoolDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.bundles_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/getBundleWithMoveDetails.query.gql}
 */
export async function getBundleWithMoveDetails(
  variables: GetBundleWithMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetBundleWithMoveDetailsQuery['bundles_by_pk']>
export async function getBundleWithMoveDetails(
  variables: GetBundleWithMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetBundleWithMoveDetailsQuery>
export async function getBundleWithMoveDetails(
  variables: GetBundleWithMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetBundleWithMoveDetailsQuery['bundles_by_pk'] | GetBundleWithMoveDetailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetBundleWithMoveDetailsQuery>(
    GetBundleWithMoveDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.bundles_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/getBundleWithMoveDetailsLightweight.query.gql}
 */
export async function getBundleWithMoveDetailsLightweight(
  variables: GetBundleWithMoveDetailsLightweightQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetBundleWithMoveDetailsLightweightQuery['bundles_by_pk']>
export async function getBundleWithMoveDetailsLightweight(
  variables: GetBundleWithMoveDetailsLightweightQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetBundleWithMoveDetailsLightweightQuery>
export async function getBundleWithMoveDetailsLightweight(
  variables: GetBundleWithMoveDetailsLightweightQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetBundleWithMoveDetailsLightweightQuery['bundles_by_pk'] | GetBundleWithMoveDetailsLightweightQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetBundleWithMoveDetailsLightweightQuery>(
    GetBundleWithMoveDetailsLightweightDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.bundles_by_pk
}

/**
 * @source {@link packages/configs/tests/storage/gql/enum-options-certifications.gql}
 */
export async function getCertificationsOptions(
  variables: GetCertificationsOptionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCertificationsOptionsQuery['certifications']>
export async function getCertificationsOptions(
  variables: GetCertificationsOptionsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCertificationsOptionsQuery>
export async function getCertificationsOptions(
  variables: GetCertificationsOptionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCertificationsOptionsQuery['certifications'] | GetCertificationsOptionsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCertificationsOptionsQuery>(
    GetCertificationsOptionsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.certifications
}

/**
 * Multiple root fields (customers, organizations): returns the full response object.
 * @source {@link packages/dispatch/src/features/driver-pool/gql/getBlacklistByCustomerAndOrg.query.gql}
 */
export async function getConfigs(
  variables: GetConfigsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetConfigsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetConfigsQuery>(
    GetConfigsDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link packages/configs/src/fetchers/gql/getCustomerConfig.query.gql}
 */
export async function getCustomerConfig(
  variables: GetCustomerConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomerConfigQuery['customers_by_pk']>
export async function getCustomerConfig(
  variables: GetCustomerConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomerConfigQuery>
export async function getCustomerConfig(
  variables: GetCustomerConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomerConfigQuery['customers_by_pk'] | GetCustomerConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomerConfigQuery>(
    GetCustomerConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers_by_pk
}

/**
 * @source {@link packages/configs/tests/storage/gql/link-table-getter-customers.gql}
 */
export async function getCustomerstocertifications(
  variables: GetCustomerstocertificationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomerstocertificationsQuery['customerstocertifications']>
export async function getCustomerstocertifications(
  variables: GetCustomerstocertificationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomerstocertificationsQuery>
export async function getCustomerstocertifications(
  variables: GetCustomerstocertificationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomerstocertificationsQuery['customerstocertifications'] | GetCustomerstocertificationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomerstocertificationsQuery>(
    GetCustomerstocertificationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customerstocertifications
}

/**
 * @source {@link packages/dispatch/src/features/driver-pool/gql/getBlacklistByLocation.query.gql}
 */
export async function getDriverBlacklistByLocations(
  variables: GetDriverBlacklistByLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriverBlacklistByLocationsQuery['driverblacklist']>
export async function getDriverBlacklistByLocations(
  variables: GetDriverBlacklistByLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriverBlacklistByLocationsQuery>
export async function getDriverBlacklistByLocations(
  variables: GetDriverBlacklistByLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriverBlacklistByLocationsQuery['driverblacklist'] | GetDriverBlacklistByLocationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriverBlacklistByLocationsQuery>(
    GetDriverBlacklistByLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.driverblacklist
}

/**
 * @source {@link packages/dispatch/src/features/drivers/gql/getDriverById.query.gql}
 */
export async function getDriverById(
  variables: GetDriverByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriverByIdQuery['drivers_by_pk']>
export async function getDriverById(
  variables: GetDriverByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriverByIdQuery>
export async function getDriverById(
  variables: GetDriverByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriverByIdQuery['drivers_by_pk'] | GetDriverByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriverByIdQuery>(
    GetDriverByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/driver-pool/gql/getDriversInRadius.query.gql}
 */
export async function getDriversInRadiusByStartingLocation(
  variables: GetDriversInRadiusByStartingLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriversInRadiusByStartingLocationQuery['drivers']>
export async function getDriversInRadiusByStartingLocation(
  variables: GetDriversInRadiusByStartingLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriversInRadiusByStartingLocationQuery>
export async function getDriversInRadiusByStartingLocation(
  variables: GetDriversInRadiusByStartingLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriversInRadiusByStartingLocationQuery['drivers'] | GetDriversInRadiusByStartingLocationQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriversInRadiusByStartingLocationQuery>(
    GetDriversInRadiusByStartingLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}

/**
 * @source {@link packages/dispatch/src/features/driver-pool/gql/getDriversLatestLocation.query.gql}
 */
export async function getDriversLatestLocation(
  variables: GetDriversLatestLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriversLatestLocationQuery['driverlocations']>
export async function getDriversLatestLocation(
  variables: GetDriversLatestLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriversLatestLocationQuery>
export async function getDriversLatestLocation(
  variables: GetDriversLatestLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriversLatestLocationQuery['driverlocations'] | GetDriversLatestLocationQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriversLatestLocationQuery>(
    GetDriversLatestLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.driverlocations
}

/**
 * @source {@link packages/dispatch/src/features/driver-pool/gql/getExistingPlans.query.gql}
 */
export async function getExistingPlans(
  variables: GetExistingPlansQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetExistingPlansQuery['plans']>
export async function getExistingPlans(
  variables: GetExistingPlansQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetExistingPlansQuery>
export async function getExistingPlans(
  variables: GetExistingPlansQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetExistingPlansQuery['plans'] | GetExistingPlansQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetExistingPlansQuery>(
    GetExistingPlansDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.plans
}

/**
 * @source {@link packages/configs/tests/integration/faq.gql}
 */
export async function getFaq(
  variables: GetFaqQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetFaqQuery['faqs_by_pk']>
export async function getFaq(
  variables: GetFaqQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetFaqQuery>
export async function getFaq(
  variables: GetFaqQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetFaqQuery['faqs_by_pk'] | GetFaqQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetFaqQuery>(
    GetFaqDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.faqs_by_pk
}

/**
 * @source {@link packages/lanes/src/features/lane-lookup/gql/getLaneById.query.gql}
 */
export async function getLaneById(
  variables: GetLaneByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLaneByIdQuery['lanes_by_pk']>
export async function getLaneById(
  variables: GetLaneByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLaneByIdQuery>
export async function getLaneById(
  variables: GetLaneByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLaneByIdQuery['lanes_by_pk'] | GetLaneByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLaneByIdQuery>(
    GetLaneByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.lanes_by_pk
}

/**
 * @source {@link packages/lanes/src/features/lane-lookup/gql/getLaneWithInverse.query.gql}
 */
export async function getLaneWithInverse(
  variables: GetLaneWithInverseQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLaneWithInverseQuery['lanes_by_pk']>
export async function getLaneWithInverse(
  variables: GetLaneWithInverseQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLaneWithInverseQuery>
export async function getLaneWithInverse(
  variables: GetLaneWithInverseQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLaneWithInverseQuery['lanes_by_pk'] | GetLaneWithInverseQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLaneWithInverseQuery>(
    GetLaneWithInverseDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.lanes_by_pk
}

/**
 * @source {@link packages/lanes/src/features/lane-lookup/gql/getLaneWithLocations.query.gql}
 */
export async function getLaneWithLocations(
  variables: GetLaneWithLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLaneWithLocationsQuery['lanes_by_pk']>
export async function getLaneWithLocations(
  variables: GetLaneWithLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLaneWithLocationsQuery>
export async function getLaneWithLocations(
  variables: GetLaneWithLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLaneWithLocationsQuery['lanes_by_pk'] | GetLaneWithLocationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLaneWithLocationsQuery>(
    GetLaneWithLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.lanes_by_pk
}

/**
 * @source {@link packages/lanes/src/features/location-lookup/gql/getLocationByCustomerRef.query.gql}
 */
export async function getLocationByCustomerRef(
  variables: GetLocationByCustomerRefQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLocationByCustomerRefQuery['locations']>
export async function getLocationByCustomerRef(
  variables: GetLocationByCustomerRefQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLocationByCustomerRefQuery>
export async function getLocationByCustomerRef(
  variables: GetLocationByCustomerRefQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLocationByCustomerRefQuery['locations'] | GetLocationByCustomerRefQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLocationByCustomerRefQuery>(
    GetLocationByCustomerRefDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations
}

/**
 * @source {@link packages/lanes/src/features/location-lookup/gql/getLocationById.query.gql}
 */
export async function getLocationById(
  variables: GetLocationByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLocationByIdQuery['locations_by_pk']>
export async function getLocationById(
  variables: GetLocationByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLocationByIdQuery>
export async function getLocationById(
  variables: GetLocationByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLocationByIdQuery['locations_by_pk'] | GetLocationByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLocationByIdQuery>(
    GetLocationByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations_by_pk
}

/**
 * @source {@link packages/moves/src/features/get-move/get-move.gql}
 */
export async function getMoveById(
  variables: GetMoveByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveByIdQuery['moves']>
export async function getMoveById(
  variables: GetMoveByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveByIdQuery>
export async function getMoveById(
  variables: GetMoveByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveByIdQuery['moves'] | GetMoveByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveByIdQuery>(
    GetMoveByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}

/**
 * @source {@link packages/configs/src/fetchers/gql/getMoveConfig.query.gql}
 */
export async function getMoveConfig(
  variables: GetMoveConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveConfigQuery['moves_by_pk']>
export async function getMoveConfig(
  variables: GetMoveConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveConfigQuery>
export async function getMoveConfig(
  variables: GetMoveConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveConfigQuery['moves_by_pk'] | GetMoveConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveConfigQuery>(
    GetMoveConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves_by_pk
}

/**
 * @source {@link packages/outcomes/src/gql/getMoveDetails.query.gql}
 */
export async function getMoveDetails(
  variables: GetMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveDetailsQuery['moves']>
export async function getMoveDetails(
  variables: GetMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveDetailsQuery>
export async function getMoveDetails(
  variables: GetMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveDetailsQuery['moves'] | GetMoveDetailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveDetailsQuery>(
    GetMoveDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/getOfferById.query.gql}
 */
export async function getOfferById(
  variables: GetOfferByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOfferByIdQuery['offers_by_pk']>
export async function getOfferById(
  variables: GetOfferByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOfferByIdQuery>
export async function getOfferById(
  variables: GetOfferByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOfferByIdQuery['offers_by_pk'] | GetOfferByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOfferByIdQuery>(
    GetOfferByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.offers_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/getOffersForBundle.query.gql}
 */
export async function getOffersForBundle(
  variables: GetOffersForBundleQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOffersForBundleQuery['offers']>
export async function getOffersForBundle(
  variables: GetOffersForBundleQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOffersForBundleQuery>
export async function getOffersForBundle(
  variables: GetOffersForBundleQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOffersForBundleQuery['offers'] | GetOffersForBundleQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOffersForBundleQuery>(
    GetOffersForBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.offers
}

/**
 * @source {@link packages/dispatch/src/features/offer-processing/gql/getOffersForBundleBasic.query.gql}
 */
export async function getOffersForBundleBasic(
  variables: GetOffersForBundleBasicQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOffersForBundleBasicQuery['offers']>
export async function getOffersForBundleBasic(
  variables: GetOffersForBundleBasicQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOffersForBundleBasicQuery>
export async function getOffersForBundleBasic(
  variables: GetOffersForBundleBasicQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOffersForBundleBasicQuery['offers'] | GetOffersForBundleBasicQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOffersForBundleBasicQuery>(
    GetOffersForBundleBasicDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.offers
}

/**
 * @source {@link packages/configs/src/fetchers/gql/getOrganizationConfig.query.gql}
 */
export async function getOrganizationConfig(
  variables: GetOrganizationConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOrganizationConfigQuery['organizations_by_pk']>
export async function getOrganizationConfig(
  variables: GetOrganizationConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOrganizationConfigQuery>
export async function getOrganizationConfig(
  variables: GetOrganizationConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOrganizationConfigQuery['organizations_by_pk'] | GetOrganizationConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOrganizationConfigQuery>(
    GetOrganizationConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.organizations_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/getPendingOffers.query.gql}
 */
export async function getPendingOffers(
  variables: GetPendingOffersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPendingOffersQuery['offers']>
export async function getPendingOffers(
  variables: GetPendingOffersQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPendingOffersQuery>
export async function getPendingOffers(
  variables: GetPendingOffersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPendingOffersQuery['offers'] | GetPendingOffersQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPendingOffersQuery>(
    GetPendingOffersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.offers
}

/**
 * @source {@link packages/dispatch/src/features/timeline/gql/getPlanByDriverId.query.gql}
 */
export async function getPlanByDriverId(
  variables: GetPlanByDriverIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPlanByDriverIdQuery['plans']>
export async function getPlanByDriverId(
  variables: GetPlanByDriverIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPlanByDriverIdQuery>
export async function getPlanByDriverId(
  variables: GetPlanByDriverIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPlanByDriverIdQuery['plans'] | GetPlanByDriverIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPlanByDriverIdQuery>(
    GetPlanByDriverIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.plans
}

/**
 * @source {@link packages/configs/src/fetchers/gql/getRateruleGroupConfig.query.gql}
 */
export async function getRateruleGroupConfig(
  variables: GetRateruleGroupConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRateruleGroupConfigQuery['raterulegroups_by_pk']>
export async function getRateruleGroupConfig(
  variables: GetRateruleGroupConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRateruleGroupConfigQuery>
export async function getRateruleGroupConfig(
  variables: GetRateruleGroupConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRateruleGroupConfigQuery['raterulegroups_by_pk'] | GetRateruleGroupConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRateruleGroupConfigQuery>(
    GetRateruleGroupConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.raterulegroups_by_pk
}

/**
 * @source {@link packages/configs/src/fetchers/gql/getRegionConfig.query.gql}
 */
export async function getRegionConfig(
  variables: GetRegionConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRegionConfigQuery['regions_by_pk']>
export async function getRegionConfig(
  variables: GetRegionConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRegionConfigQuery>
export async function getRegionConfig(
  variables: GetRegionConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRegionConfigQuery['regions_by_pk'] | GetRegionConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRegionConfigQuery>(
    GetRegionConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.regions_by_pk
}

/**
 * @source {@link packages/configs/tests/storage/gql/link-table-getter-regions.gql}
 */
export async function getRegionstocertifications(
  variables: GetRegionstocertificationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRegionstocertificationsQuery['regionstocertifications']>
export async function getRegionstocertifications(
  variables: GetRegionstocertificationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRegionstocertificationsQuery>
export async function getRegionstocertifications(
  variables: GetRegionstocertificationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRegionstocertificationsQuery['regionstocertifications'] | GetRegionstocertificationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRegionstocertificationsQuery>(
    GetRegionstocertificationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.regionstocertifications
}

/**
 * Multiple root fields (usecasetocertifications, customerstocertifications, organizationstocertifications, locationstocertifications, scenariotypestocertifications): returns the full response object.
 * @source {@link packages/dispatch/src/features/driver-pool/gql/getRequiredCertifications.query.gql}
 */
export async function getRequiredCertifications(
  variables: GetRequiredCertificationsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetRequiredCertificationsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetRequiredCertificationsQuery>(
    GetRequiredCertificationsDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link packages/accessorials/src/features/ride/gql/getRideAccessorials.query.gql}
 */
export async function getRideAccessorials(
  variables: GetRideAccessorialsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRideAccessorialsQuery['accessorials']>
export async function getRideAccessorials(
  variables: GetRideAccessorialsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRideAccessorialsQuery>
export async function getRideAccessorials(
  variables: GetRideAccessorialsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRideAccessorialsQuery['accessorials'] | GetRideAccessorialsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRideAccessorialsQuery>(
    GetRideAccessorialsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.accessorials
}

/**
 * @source {@link packages/accessorials/src/features/ridegroup/gql/getRidegroupAccessorials.query.gql}
 */
export async function getRidegroupAccessorials(
  variables: GetRidegroupAccessorialsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRidegroupAccessorialsQuery['accessorials']>
export async function getRidegroupAccessorials(
  variables: GetRidegroupAccessorialsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRidegroupAccessorialsQuery>
export async function getRidegroupAccessorials(
  variables: GetRidegroupAccessorialsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRidegroupAccessorialsQuery['accessorials'] | GetRidegroupAccessorialsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRidegroupAccessorialsQuery>(
    GetRidegroupAccessorialsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.accessorials
}

/**
 * @source {@link packages/events/src/features/lookup-types/gql/getRoleTypeByName.query.gql}
 */
export async function getRoleTypeByName(
  variables: GetRoleTypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRoleTypeByNameQuery['roletypes']>
export async function getRoleTypeByName(
  variables: GetRoleTypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRoleTypeByNameQuery>
export async function getRoleTypeByName(
  variables: GetRoleTypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRoleTypeByNameQuery['roletypes'] | GetRoleTypeByNameQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRoleTypeByNameQuery>(
    GetRoleTypeByNameDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.roletypes
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/getScenario.query.gql}
 */
export async function getScenario(
  variables: GetScenarioQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScenarioQuery['scenarios_by_pk']>
export async function getScenario(
  variables: GetScenarioQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScenarioQuery>
export async function getScenario(
  variables: GetScenarioQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScenarioQuery['scenarios_by_pk'] | GetScenarioQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScenarioQuery>(
    GetScenarioDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.scenarios_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/getScenarioBundle.query.gql}
 */
export async function getScenarioBundle(
  variables: GetScenarioBundleQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScenarioBundleQuery['bundletoscenarios']>
export async function getScenarioBundle(
  variables: GetScenarioBundleQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScenarioBundleQuery>
export async function getScenarioBundle(
  variables: GetScenarioBundleQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScenarioBundleQuery['bundletoscenarios'] | GetScenarioBundleQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScenarioBundleQuery>(
    GetScenarioBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.bundletoscenarios
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/getScenarioById.query.gql}
 */
export async function getScenarioById(
  variables: GetScenarioByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScenarioByIdQuery['scenarios_by_pk']>
export async function getScenarioById(
  variables: GetScenarioByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScenarioByIdQuery>
export async function getScenarioById(
  variables: GetScenarioByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScenarioByIdQuery['scenarios_by_pk'] | GetScenarioByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScenarioByIdQuery>(
    GetScenarioByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.scenarios_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/offer-processing/gql/getScenariosByIds.query.gql}
 */
export async function getScenariosByIds(
  variables: GetScenariosByIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScenariosByIdsQuery['scenarios']>
export async function getScenariosByIds(
  variables: GetScenariosByIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScenariosByIdsQuery>
export async function getScenariosByIds(
  variables: GetScenariosByIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScenariosByIdsQuery['scenarios'] | GetScenariosByIdsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScenariosByIdsQuery>(
    GetScenariosByIdsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.scenarios
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/getScenarioToConvertOrRepair.query.gql}
 */
export async function getScenarioToConvertOrRepair(
  variables: GetScenarioToConvertOrRepairQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScenarioToConvertOrRepairQuery['scenarios_by_pk']>
export async function getScenarioToConvertOrRepair(
  variables: GetScenarioToConvertOrRepairQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScenarioToConvertOrRepairQuery>
export async function getScenarioToConvertOrRepair(
  variables: GetScenarioToConvertOrRepairQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScenarioToConvertOrRepairQuery['scenarios_by_pk'] | GetScenarioToConvertOrRepairQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScenarioToConvertOrRepairQuery>(
    GetScenarioToConvertOrRepairDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.scenarios_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/getScenarioWithMoves.query.gql}
 */
export async function getScenarioWithMoves(
  variables: GetScenarioWithMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScenarioWithMovesQuery['scenarios_by_pk']>
export async function getScenarioWithMoves(
  variables: GetScenarioWithMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScenarioWithMovesQuery>
export async function getScenarioWithMoves(
  variables: GetScenarioWithMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScenarioWithMovesQuery['scenarios_by_pk'] | GetScenarioWithMovesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScenarioWithMovesQuery>(
    GetScenarioWithMovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.scenarios_by_pk
}

/**
 * @source {@link packages/configs/src/fetchers/gql/getWorkflowsetConfig.query.gql}
 */
export async function getWorkflowsetConfig(
  variables: GetWorkflowsetConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetWorkflowsetConfigQuery['workflowsets_by_pk']>
export async function getWorkflowsetConfig(
  variables: GetWorkflowsetConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetWorkflowsetConfigQuery>
export async function getWorkflowsetConfig(
  variables: GetWorkflowsetConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetWorkflowsetConfigQuery['workflowsets_by_pk'] | GetWorkflowsetConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetWorkflowsetConfigQuery>(
    GetWorkflowsetConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.workflowsets_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/insertRidegroups.mutation.gql}
 */
export async function insert_ridegroups(
  variables: Insert_RidegroupsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<Insert_RidegroupsMutation['insert_ridegroups']>
export async function insert_ridegroups(
  variables: Insert_RidegroupsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<Insert_RidegroupsMutation>
export async function insert_ridegroups(
  variables: Insert_RidegroupsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<Insert_RidegroupsMutation['insert_ridegroups'] | Insert_RidegroupsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<Insert_RidegroupsMutation>(
    Insert_RidegroupsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_ridegroups
}

/**
 * @source {@link packages/events/src/features/create-event/gql/insertEventlog.mutation.gql}
 */
export async function insertEventlog(
  variables: InsertEventlogMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertEventlogMutation['insert_eventlogs_one']>
export async function insertEventlog(
  variables: InsertEventlogMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertEventlogMutation>
export async function insertEventlog(
  variables: InsertEventlogMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertEventlogMutation['insert_eventlogs_one'] | InsertEventlogMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertEventlogMutation>(
    InsertEventlogDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_eventlogs_one
}

/**
 * @source {@link packages/configs/tests/integration/faq.gql}
 */
export async function insertFaq(
  variables: InsertFaqMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertFaqMutation['insert_faqs_one']>
export async function insertFaq(
  variables: InsertFaqMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertFaqMutation>
export async function insertFaq(
  variables: InsertFaqMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertFaqMutation['insert_faqs_one'] | InsertFaqMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertFaqMutation>(
    InsertFaqDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_faqs_one
}

/**
 * @source {@link packages/accessorials/src/features/ride/gql/insertTriangleAccessorial.mutation.gql}
 */
export async function insertTriangleAccessorial(
  variables: InsertTriangleAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertTriangleAccessorialMutation['insert_accessorials']>
export async function insertTriangleAccessorial(
  variables: InsertTriangleAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertTriangleAccessorialMutation>
export async function insertTriangleAccessorial(
  variables: InsertTriangleAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertTriangleAccessorialMutation['insert_accessorials'] | InsertTriangleAccessorialMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertTriangleAccessorialMutation>(
    InsertTriangleAccessorialDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_accessorials
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/inverseConcierge.mutation.gql}
 */
export async function inverseConcierge(
  variables: InverseConciergeMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InverseConciergeMutation['update_moves']>
export async function inverseConcierge(
  variables: InverseConciergeMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InverseConciergeMutation>
export async function inverseConcierge(
  variables: InverseConciergeMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InverseConciergeMutation['update_moves'] | InverseConciergeMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InverseConciergeMutation>(
    InverseConciergeDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}

/**
 * Multiple root fields (updateMove1, updateMove2): returns the full response object.
 * @source {@link packages/dispatch/src/features/scenarios/gql/inverseConciergeLoaner.mutation.gql}
 */
export async function inverseConciergeLoaner(
  variables: InverseConciergeLoanerMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<InverseConciergeLoanerMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<InverseConciergeLoanerMutation>(
    InverseConciergeLoanerDocument,
    variables,
    requestOptions
  )
}

/**
 * Multiple root fields (updateMove1, updateMove2): returns the full response object.
 * @source {@link packages/dispatch/src/features/scenarios/gql/inverseFlexibleFlags.mutation.gql}
 */
export async function inverseFlexibleFlags(
  variables: InverseFlexibleFlagsMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<InverseFlexibleFlagsMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<InverseFlexibleFlagsMutation>(
    InverseFlexibleFlagsDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/linkMoveToScenario.mutation.gql}
 */
export async function linkMoveToScenario(
  variables: LinkMoveToScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<LinkMoveToScenarioMutation['insert_scenariotomoves_one']>
export async function linkMoveToScenario(
  variables: LinkMoveToScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<LinkMoveToScenarioMutation>
export async function linkMoveToScenario(
  variables: LinkMoveToScenarioMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<LinkMoveToScenarioMutation['insert_scenariotomoves_one'] | LinkMoveToScenarioMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<LinkMoveToScenarioMutation>(
    LinkMoveToScenarioDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_scenariotomoves_one
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/linkScenarioToBundle.mutation.gql}
 */
export async function linkScenarioToBundle(
  variables: LinkScenarioToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<LinkScenarioToBundleMutation['insert_bundletoscenarios_one']>
export async function linkScenarioToBundle(
  variables: LinkScenarioToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<LinkScenarioToBundleMutation>
export async function linkScenarioToBundle(
  variables: LinkScenarioToBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<LinkScenarioToBundleMutation['insert_bundletoscenarios_one'] | LinkScenarioToBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<LinkScenarioToBundleMutation>(
    LinkScenarioToBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_bundletoscenarios_one
}

/**
 * @source {@link packages/lanes/src/features/resolve-location/gql/recordInputAlias.mutation.gql}
 */
export async function recordInputAlias(
  variables: RecordInputAliasMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RecordInputAliasMutation['insert_location_input_aliases_one']>
export async function recordInputAlias(
  variables: RecordInputAliasMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RecordInputAliasMutation>
export async function recordInputAlias(
  variables: RecordInputAliasMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RecordInputAliasMutation['insert_location_input_aliases_one'] | RecordInputAliasMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RecordInputAliasMutation>(
    RecordInputAliasDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_location_input_aliases_one
}

/**
 * @source {@link packages/accessorials/src/features/ridegroup/gql/removeAccessorials.mutation.gql}
 */
export async function removeAccessorials(
  variables: RemoveAccessorialsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RemoveAccessorialsMutation['delete_accessorials']>
export async function removeAccessorials(
  variables: RemoveAccessorialsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RemoveAccessorialsMutation>
export async function removeAccessorials(
  variables: RemoveAccessorialsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RemoveAccessorialsMutation['delete_accessorials'] | RemoveAccessorialsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RemoveAccessorialsMutation>(
    RemoveAccessorialsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_accessorials
}

/**
 * @source {@link packages/accessorials/src/features/ridegroup/gql/removeAppayments.mutation.gql}
 */
export async function removeAppayments(
  variables: RemoveAppaymentsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RemoveAppaymentsMutation['delete_appayments']>
export async function removeAppayments(
  variables: RemoveAppaymentsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RemoveAppaymentsMutation>
export async function removeAppayments(
  variables: RemoveAppaymentsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RemoveAppaymentsMutation['delete_appayments'] | RemoveAppaymentsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RemoveAppaymentsMutation>(
    RemoveAppaymentsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_appayments
}

/**
 * Multiple root fields (delete_scenariotomoves, update_moves): returns the full response object.
 * @source {@link packages/dispatch/src/features/scenarios/gql/removeRideMoves.mutation.gql}
 */
export async function removeRideMoves(
  variables: RemoveRideMovesMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<RemoveRideMovesMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<RemoveRideMovesMutation>(
    RemoveRideMovesDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link packages/lanes/src/features/resolve-lane/gql/resolveLaneByLocations.query.gql}
 */
export async function resolveLaneByLocations(
  variables: ResolveLaneByLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<ResolveLaneByLocationsQuery['lanes']>
export async function resolveLaneByLocations(
  variables: ResolveLaneByLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<ResolveLaneByLocationsQuery>
export async function resolveLaneByLocations(
  variables: ResolveLaneByLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<ResolveLaneByLocationsQuery['lanes'] | ResolveLaneByLocationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<ResolveLaneByLocationsQuery>(
    ResolveLaneByLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.lanes
}

/**
 * Multiple root fields (delete_regionstocertifications, insert_regionstocertifications): returns the full response object.
 * @source {@link packages/configs/tests/storage/gql/link-table-setter-regions.gql}
 */
export async function setRegionstocertifications(
  variables: SetRegionstocertificationsMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<SetRegionstocertificationsMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<SetRegionstocertificationsMutation>(
    SetRegionstocertificationsDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link packages/configs/tests/storage/gql/jsonb-getter-customer.gql}
 */
export async function storageCustomerConfigGet(
  variables: StorageCustomerConfigGetQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<StorageCustomerConfigGetQuery['customers_by_pk']>
export async function storageCustomerConfigGet(
  variables: StorageCustomerConfigGetQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<StorageCustomerConfigGetQuery>
export async function storageCustomerConfigGet(
  variables: StorageCustomerConfigGetQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<StorageCustomerConfigGetQuery['customers_by_pk'] | StorageCustomerConfigGetQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<StorageCustomerConfigGetQuery>(
    StorageCustomerConfigGetDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers_by_pk
}

/**
 * @source {@link packages/configs/tests/storage/gql/jsonb-setter-customer.gql}
 */
export async function storageCustomerConfigSet(
  variables: StorageCustomerConfigSetMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<StorageCustomerConfigSetMutation['update_customers_by_pk']>
export async function storageCustomerConfigSet(
  variables: StorageCustomerConfigSetMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<StorageCustomerConfigSetMutation>
export async function storageCustomerConfigSet(
  variables: StorageCustomerConfigSetMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<StorageCustomerConfigSetMutation['update_customers_by_pk'] | StorageCustomerConfigSetMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<StorageCustomerConfigSetMutation>(
    StorageCustomerConfigSetDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_customers_by_pk
}

/**
 * @source {@link packages/configs/tests/storage/gql/jsonb-getter-region.gql}
 */
export async function storageRegionConfigGet(
  variables: StorageRegionConfigGetQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<StorageRegionConfigGetQuery['regions_by_pk']>
export async function storageRegionConfigGet(
  variables: StorageRegionConfigGetQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<StorageRegionConfigGetQuery>
export async function storageRegionConfigGet(
  variables: StorageRegionConfigGetQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<StorageRegionConfigGetQuery['regions_by_pk'] | StorageRegionConfigGetQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<StorageRegionConfigGetQuery>(
    StorageRegionConfigGetDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.regions_by_pk
}

/**
 * @source {@link packages/lanes/src/features/geocoding/gql/storeGeocodeCache.mutation.gql}
 */
export async function storeGeocodeCache(
  variables: StoreGeocodeCacheMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<StoreGeocodeCacheMutation['insert_geocode_cache_one']>
export async function storeGeocodeCache(
  variables: StoreGeocodeCacheMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<StoreGeocodeCacheMutation>
export async function storeGeocodeCache(
  variables: StoreGeocodeCacheMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<StoreGeocodeCacheMutation['insert_geocode_cache_one'] | StoreGeocodeCacheMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<StoreGeocodeCacheMutation>(
    StoreGeocodeCacheDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_geocode_cache_one
}

/**
 * @source {@link packages/lanes/src/features/resolve-lane/gql/triggerLaneEnrichment.mutation.gql}
 */
export async function triggerLaneEnrichment(
  variables: TriggerLaneEnrichmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<TriggerLaneEnrichmentMutation['update_lanes']>
export async function triggerLaneEnrichment(
  variables: TriggerLaneEnrichmentMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<TriggerLaneEnrichmentMutation>
export async function triggerLaneEnrichment(
  variables: TriggerLaneEnrichmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<TriggerLaneEnrichmentMutation['update_lanes'] | TriggerLaneEnrichmentMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<TriggerLaneEnrichmentMutation>(
    TriggerLaneEnrichmentDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_lanes
}

/**
 * @source {@link packages/outcomes/src/gql/unassignHangtag.mutation.gql}
 */
export async function unassignHangtag(
  variables: UnassignHangtagMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UnassignHangtagMutation['update_hangtags']>
export async function unassignHangtag(
  variables: UnassignHangtagMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UnassignHangtagMutation>
export async function unassignHangtag(
  variables: UnassignHangtagMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UnassignHangtagMutation['update_hangtags'] | UnassignHangtagMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UnassignHangtagMutation>(
    UnassignHangtagDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_hangtags
}

/**
 * @source {@link packages/accessorials/src/features/shared/operations/gql/updateAccessorial.mutation.gql}
 */
export async function updateAccessorial(
  variables: UpdateAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateAccessorialMutation['update_accessorials']>
export async function updateAccessorial(
  variables: UpdateAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateAccessorialMutation>
export async function updateAccessorial(
  variables: UpdateAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateAccessorialMutation['update_accessorials'] | UpdateAccessorialMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateAccessorialMutation>(
    UpdateAccessorialDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_accessorials
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/updateAllOfferStatusesForBundle.mutation.gql}
 */
export async function updateAllOfferStatusesForBundle(
  variables: UpdateAllOfferStatusesForBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateAllOfferStatusesForBundleMutation['update_offers']>
export async function updateAllOfferStatusesForBundle(
  variables: UpdateAllOfferStatusesForBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateAllOfferStatusesForBundleMutation>
export async function updateAllOfferStatusesForBundle(
  variables: UpdateAllOfferStatusesForBundleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateAllOfferStatusesForBundleMutation['update_offers'] | UpdateAllOfferStatusesForBundleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateAllOfferStatusesForBundleMutation>(
    UpdateAllOfferStatusesForBundleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_offers
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/updateBundleConfig.mutation.gql}
 */
export async function updateBundleConfig(
  variables: UpdateBundleConfigMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateBundleConfigMutation['update_bundles_by_pk']>
export async function updateBundleConfig(
  variables: UpdateBundleConfigMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateBundleConfigMutation>
export async function updateBundleConfig(
  variables: UpdateBundleConfigMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateBundleConfigMutation['update_bundles_by_pk'] | UpdateBundleConfigMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateBundleConfigMutation>(
    UpdateBundleConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_bundles_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateBundleScenariosStatus.mutation.gql}
 */
export async function updateBundleScenariosStatus(
  variables: UpdateBundleScenariosStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateBundleScenariosStatusMutation['update_scenarios']>
export async function updateBundleScenariosStatus(
  variables: UpdateBundleScenariosStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateBundleScenariosStatusMutation>
export async function updateBundleScenariosStatus(
  variables: UpdateBundleScenariosStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateBundleScenariosStatusMutation['update_scenarios'] | UpdateBundleScenariosStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateBundleScenariosStatusMutation>(
    UpdateBundleScenariosStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_scenarios
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/updateBundleStatus.mutation.gql}
 */
export async function updateBundleStatus(
  variables: UpdateBundleStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateBundleStatusMutation['update_bundles_by_pk']>
export async function updateBundleStatus(
  variables: UpdateBundleStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateBundleStatusMutation>
export async function updateBundleStatus(
  variables: UpdateBundleStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateBundleStatusMutation['update_bundles_by_pk'] | UpdateBundleStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateBundleStatusMutation>(
    UpdateBundleStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_bundles_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/bundles/gql/updateBundleStatuses.mutation.gql}
 */
export async function updateBundleStatuses(
  variables: UpdateBundleStatusesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateBundleStatusesMutation['update_bundles']>
export async function updateBundleStatuses(
  variables: UpdateBundleStatusesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateBundleStatusesMutation>
export async function updateBundleStatuses(
  variables: UpdateBundleStatusesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateBundleStatusesMutation['update_bundles'] | UpdateBundleStatusesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateBundleStatusesMutation>(
    UpdateBundleStatusesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_bundles
}

/**
 * @source {@link packages/configs/tests/integration/faq.gql}
 */
export async function updateFaqFull(
  variables: UpdateFaqFullMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateFaqFullMutation['update_faqs_by_pk']>
export async function updateFaqFull(
  variables: UpdateFaqFullMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateFaqFullMutation>
export async function updateFaqFull(
  variables: UpdateFaqFullMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateFaqFullMutation['update_faqs_by_pk'] | UpdateFaqFullMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateFaqFullMutation>(
    UpdateFaqFullDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_faqs_by_pk
}

/**
 * @source {@link packages/lanes/src/features/enrichment/gql/updateLaneEnrichment.mutation.gql}
 */
export async function updateLaneEnrichment(
  variables: UpdateLaneEnrichmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateLaneEnrichmentMutation['update_lanes_by_pk']>
export async function updateLaneEnrichment(
  variables: UpdateLaneEnrichmentMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateLaneEnrichmentMutation>
export async function updateLaneEnrichment(
  variables: UpdateLaneEnrichmentMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateLaneEnrichmentMutation['update_lanes_by_pk'] | UpdateLaneEnrichmentMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateLaneEnrichmentMutation>(
    UpdateLaneEnrichmentDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_lanes_by_pk
}

/**
 * @source {@link packages/lanes/src/features/lane-update/gql/updateLaneStatus.mutation.gql}
 */
export async function updateLaneStatus(
  variables: UpdateLaneStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateLaneStatusMutation['update_lanes']>
export async function updateLaneStatus(
  variables: UpdateLaneStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateLaneStatusMutation>
export async function updateLaneStatus(
  variables: UpdateLaneStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateLaneStatusMutation['update_lanes'] | UpdateLaneStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateLaneStatusMutation>(
    UpdateLaneStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_lanes
}

/**
 * @source {@link packages/lanes/src/features/lane-update/gql/updateLaneStatusReady.mutation.gql}
 */
export async function updateLaneStatusReady(
  variables: UpdateLaneStatusReadyMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateLaneStatusReadyMutation['update_lanes']>
export async function updateLaneStatusReady(
  variables: UpdateLaneStatusReadyMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateLaneStatusReadyMutation>
export async function updateLaneStatusReady(
  variables: UpdateLaneStatusReadyMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateLaneStatusReadyMutation['update_lanes'] | UpdateLaneStatusReadyMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateLaneStatusReadyMutation>(
    UpdateLaneStatusReadyDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_lanes
}

/**
 * @source {@link packages/outcomes/src/gql/updateMoveWithAdjustments.mutation.gql}
 */
export async function updateMoveWithAdjustments(
  variables: UpdateMoveWithAdjustmentsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateMoveWithAdjustmentsMutation['update_moves']>
export async function updateMoveWithAdjustments(
  variables: UpdateMoveWithAdjustmentsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateMoveWithAdjustmentsMutation>
export async function updateMoveWithAdjustments(
  variables: UpdateMoveWithAdjustmentsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateMoveWithAdjustmentsMutation['update_moves'] | UpdateMoveWithAdjustmentsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateMoveWithAdjustmentsMutation>(
    UpdateMoveWithAdjustmentsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}

/**
 * @source {@link packages/dispatch/src/features/offers/gql/updateOfferStatus.mutation.gql}
 */
export async function updateOfferStatus(
  variables: UpdateOfferStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateOfferStatusMutation['update_offers_by_pk']>
export async function updateOfferStatus(
  variables: UpdateOfferStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateOfferStatusMutation>
export async function updateOfferStatus(
  variables: UpdateOfferStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateOfferStatusMutation['update_offers_by_pk'] | UpdateOfferStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateOfferStatusMutation>(
    UpdateOfferStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_offers_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateMovePickupAndDeliveryTime.mutation.gql}
 */
export async function updatePickupAndDeliveryTime(
  variables: UpdatePickupAndDeliveryTimeMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdatePickupAndDeliveryTimeMutation['update_moves']>
export async function updatePickupAndDeliveryTime(
  variables: UpdatePickupAndDeliveryTimeMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdatePickupAndDeliveryTimeMutation>
export async function updatePickupAndDeliveryTime(
  variables: UpdatePickupAndDeliveryTimeMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdatePickupAndDeliveryTimeMutation['update_moves'] | UpdatePickupAndDeliveryTimeMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdatePickupAndDeliveryTimeMutation>(
    UpdatePickupAndDeliveryTimeDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}

/**
 * @source {@link packages/outcomes/src/gql/updateRescheduledMove.mutation.gql}
 */
export async function updateRescheduledMove(
  variables: UpdateRescheduledMoveMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateRescheduledMoveMutation['update_moves']>
export async function updateRescheduledMove(
  variables: UpdateRescheduledMoveMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateRescheduledMoveMutation>
export async function updateRescheduledMove(
  variables: UpdateRescheduledMoveMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateRescheduledMoveMutation['update_moves'] | UpdateRescheduledMoveMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateRescheduledMoveMutation>(
    UpdateRescheduledMoveDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}

/**
 * @source {@link packages/accessorials/src/features/ride/gql/updateRideAccessorial.mutation.gql}
 */
export async function updateRideAccessorial(
  variables: UpdateRideAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateRideAccessorialMutation['update_accessorials']>
export async function updateRideAccessorial(
  variables: UpdateRideAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateRideAccessorialMutation>
export async function updateRideAccessorial(
  variables: UpdateRideAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateRideAccessorialMutation['update_accessorials'] | UpdateRideAccessorialMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateRideAccessorialMutation>(
    UpdateRideAccessorialDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_accessorials
}

/**
 * @source {@link packages/outcomes/src/gql/updateRides.mutation.gql}
 */
export async function updateRides(
  variables: UpdateRidesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateRidesMutation['update_moves']>
export async function updateRides(
  variables: UpdateRidesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateRidesMutation>
export async function updateRides(
  variables: UpdateRidesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateRidesMutation['update_moves'] | UpdateRidesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateRidesMutation>(
    UpdateRidesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateScenarioConfig.mutation.gql}
 */
export async function updateScenarioConfig(
  variables: UpdateScenarioConfigMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateScenarioConfigMutation['update_scenarios_by_pk']>
export async function updateScenarioConfig(
  variables: UpdateScenarioConfigMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateScenarioConfigMutation>
export async function updateScenarioConfig(
  variables: UpdateScenarioConfigMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateScenarioConfigMutation['update_scenarios_by_pk'] | UpdateScenarioConfigMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateScenarioConfigMutation>(
    UpdateScenarioConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_scenarios_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateScenarioStatus.mutation.gql}
 */
export async function updateScenarioStatus(
  variables: UpdateScenarioStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateScenarioStatusMutation['update_scenarios_by_pk']>
export async function updateScenarioStatus(
  variables: UpdateScenarioStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateScenarioStatusMutation>
export async function updateScenarioStatus(
  variables: UpdateScenarioStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateScenarioStatusMutation['update_scenarios_by_pk'] | UpdateScenarioStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateScenarioStatusMutation>(
    UpdateScenarioStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_scenarios_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateScenarioStatuses.mutation.gql}
 */
export async function updateScenarioStatuses(
  variables: UpdateScenarioStatusesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateScenarioStatusesMutation['update_scenarios']>
export async function updateScenarioStatuses(
  variables: UpdateScenarioStatusesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateScenarioStatusesMutation>
export async function updateScenarioStatuses(
  variables: UpdateScenarioStatusesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateScenarioStatusesMutation['update_scenarios'] | UpdateScenarioStatusesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateScenarioStatusesMutation>(
    UpdateScenarioStatusesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_scenarios
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateScenarioType.mutation.gql}
 */
export async function updateScenarioType(
  variables: UpdateScenarioTypeMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateScenarioTypeMutation['update_scenarios_by_pk']>
export async function updateScenarioType(
  variables: UpdateScenarioTypeMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateScenarioTypeMutation>
export async function updateScenarioType(
  variables: UpdateScenarioTypeMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateScenarioTypeMutation['update_scenarios_by_pk'] | UpdateScenarioTypeMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateScenarioTypeMutation>(
    UpdateScenarioTypeDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_scenarios_by_pk
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/updateScenarioWorkflowData.mutation.gql}
 */
export async function updateScenarioWorkflowData(
  variables: UpdateScenarioWorkflowDataMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateScenarioWorkflowDataMutation['update_scenarios_by_pk']>
export async function updateScenarioWorkflowData(
  variables: UpdateScenarioWorkflowDataMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateScenarioWorkflowDataMutation>
export async function updateScenarioWorkflowData(
  variables: UpdateScenarioWorkflowDataMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateScenarioWorkflowDataMutation['update_scenarios_by_pk'] | UpdateScenarioWorkflowDataMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateScenarioWorkflowDataMutation>(
    UpdateScenarioWorkflowDataDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_scenarios_by_pk
}

/**
 * @source {@link packages/accessorials/src/features/surge/gql/updateSurgeAccessorial.mutation.gql}
 */
export async function updateSurgeAccessorial(
  variables: UpdateSurgeAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateSurgeAccessorialMutation['update_accessorials']>
export async function updateSurgeAccessorial(
  variables: UpdateSurgeAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateSurgeAccessorialMutation>
export async function updateSurgeAccessorial(
  variables: UpdateSurgeAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateSurgeAccessorialMutation['update_accessorials'] | UpdateSurgeAccessorialMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateSurgeAccessorialMutation>(
    UpdateSurgeAccessorialDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_accessorials
}

/**
 * @source {@link packages/accessorials/src/features/ride/gql/updateTriangleRideAccessorial.mutation.gql}
 */
export async function updateTriangleRideAccessorial(
  variables: UpdateTriangleRideAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateTriangleRideAccessorialMutation['update_accessorials']>
export async function updateTriangleRideAccessorial(
  variables: UpdateTriangleRideAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateTriangleRideAccessorialMutation>
export async function updateTriangleRideAccessorial(
  variables: UpdateTriangleRideAccessorialMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateTriangleRideAccessorialMutation['update_accessorials'] | UpdateTriangleRideAccessorialMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateTriangleRideAccessorialMutation>(
    UpdateTriangleRideAccessorialDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_accessorials
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/upsertMoves.mutation.gql}
 */
export async function upsert_moves(
  variables: Upsert_MovesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<Upsert_MovesMutation['insert_moves']>
export async function upsert_moves(
  variables: Upsert_MovesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<Upsert_MovesMutation>
export async function upsert_moves(
  variables: Upsert_MovesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<Upsert_MovesMutation['insert_moves'] | Upsert_MovesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<Upsert_MovesMutation>(
    Upsert_MovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_moves
}

/**
 * @source {@link packages/dispatch/src/features/scenarios/gql/upsertRideMoves.mutation.gql}
 */
export async function upsertRideMoves(
  variables: UpsertRideMovesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpsertRideMovesMutation['insert_moves']>
export async function upsertRideMoves(
  variables: UpsertRideMovesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpsertRideMovesMutation>
export async function upsertRideMoves(
  variables: UpsertRideMovesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpsertRideMovesMutation['insert_moves'] | UpsertRideMovesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpsertRideMovesMutation>(
    UpsertRideMovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_moves
}